import { AlertTriangle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import type { EnhancementProps } from './index';

/** #2434 — shown under Yahoo DSP's Advertiser scope while the form holds the
 *  withdrawn "selected" value, which only a configuration stored with it can.
 *  The schema no longer offers that option, so the select shows no value, and
 *  it must not read as "All advertisers" before the user picks it. The backend
 *  refuses the value on every save and every run with the same reason. */
export function YahooAdvertiserScopeNotice({ formValues }: EnhancementProps) {
  if (formValues.advertiser_scope !== 'selected') return null;
  return (
    <Alert variant="warning" className="mt-2" data-testid="yahoo-advertiser-scope-withdrawn">
      <AlertTriangle className="h-4 w-4" aria-hidden />
      <AlertTitle>&ldquo;Only the selected advertisers&rdquo; is no longer supported</AlertTitle>
      <AlertDescription>
        <p className="text-foreground">
          This configuration is stored with that scope. Yahoo ignores the Advertiser filter on the
          Day reports a run sends (measured on every standard report, #2350), so a run would
          download every advertiser&rsquo;s rows. Its runs fail, and a save of its settings is
          refused, until you choose &ldquo;All advertisers visible to the login&rdquo; above.
        </p>
      </AlertDescription>
    </Alert>
  );
}
